import _ from 'lodash';
import moment from 'moment';
import laborRateModal from "../../../common/modals/laborRateModal/laborRateModal.component";
import viewChargeCodesModal from "../../../common/modals/viewChargeCodesModal/viewChargeCodesModal.component";
import formatCurrency from "format-currency";


class SubcontractDetailsController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService, $stateParams, $uibModal, $q) {
    "ngInject";
    this.name = 'subcontractor';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$uibModal = $uibModal;
    this.$q = $q;
    this.subcontract = null;
    this.attachedContract = null;

    this.laborRateFilter = {
      name: ''
    };
    this.laborRateSort = {
      field: 'name',
      reverse: false
    };
    this.fixedFeeBasisList = [];
    this.selectedLaborRatePop = null;
    this.activeLaborRatePopIndex = 0;
    this.customers = [];
    this.selectedCustomer = null;

    let self = this;
    this.$http.get($rootScope.apiHost + "/api/admin/subcontracts/" + $stateParams.subcontractId, { withCredentials: true }).then(function (success) {
      self.subcontract = success.data;
      self.$http.get($rootScope.apiHost + "/api/admin/contracts/" + self.subcontract.associatedContract.id, { withCredentials: true }).then(function (contractSuccess) {
        self.attachedContract = contractSuccess.data;
        self.initLaborRates();
        self.initLaborRatePopTab();
        if (self.isCostBasedContract()) {
          self.loadFixedFeeBasis();
        }
        self.loadCustomerForNaming();
      });
    });
  }

  loadCustomerForNaming() {
    let self = this;
    if (!this.attachedContract || !this.attachedContract.customerId) {
      return;
    }
    this.$http.get(this.$rootScope.apiHost + '/api/admin/customers/' + this.attachedContract.customerId, { withCredentials: true })
      .then(function (success) {
        self.selectedCustomer = success.data;
      })
      .catch(function () {
        self.selectedCustomer = {
          shortName: self.attachedContract.shortName
        };
      });
  }

  loadSubContract() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost + "/api/admin/subcontracts/" + this.$stateParams.subcontractId, { withCredentials: true }).then(function (success) {
      self.subcontract = success.data;
      self.initLaborRates();
      self.initLaborRatePopTab();
      if (self.isCostBasedContract()) {
        self.loadFixedFeeBasis();
      }
    });
  }

  checkXEditPermission(permission) {
    return this.auth.hasPermission(permission);
  }

  checkPermission(e, permission) {
    if (!this.auth.hasPermission(permission)) {
      e.preventDefault();
    }
  }

  isCostBasedContract() {
    if (this.attachedContract && this.attachedContract.contractType) {
      return this.attachedContract.contractType === 'CPFF' || this.attachedContract.contractType === 'CPAF';
    }
    return false;
  }

  isActivePeriodOfPerformance(pop) {
    if (!pop || !pop.startDate || !pop.endDate) {
      return false;
    }
    const now = moment();
    return now.isSameOrAfter(moment(pop.startDate), 'day') && now.isSameOrBefore(moment(pop.endDate), 'day');
  }

  getOrderedPeriodsOfPerformance() {
    if (!this.attachedContract || !this.attachedContract.periodsOfPerformance) {
      return [];
    }
    return _.sortBy(this.attachedContract.periodsOfPerformance, 'startDate');
  }

  initLaborRatePopTab() {
    const pops = this.getOrderedPeriodsOfPerformance();
    if (!pops.length) {
      this.selectedLaborRatePop = null;
      this.activeLaborRatePopIndex = 0;
      return;
    }

    let selectedIndex = pops.findIndex((pop) => this.isActivePeriodOfPerformance(pop));
    if (selectedIndex < 0) {
      selectedIndex = 0;
    }

    this.selectedLaborRatePop = pops[selectedIndex];
    this.activeLaborRatePopIndex = selectedIndex;
    this.laborRateSort.field = 'popRate_' + this.selectedLaborRatePop.id;
  }

  onLaborRatePopSelected(pop) {
    this.selectedLaborRatePop = pop;
    if (pop && pop.id) {
      this.laborRateSort.field = 'popRate_' + pop.id;
    }
  }

  getSelectedLaborRatePop() {
    if (this.selectedLaborRatePop) {
      return this.selectedLaborRatePop;
    }
    const pops = this.getOrderedPeriodsOfPerformance();
    return pops.length ? pops[0] : null;
  }

  getPopRateForLaborRate(laborRate, pop) {
    if (!laborRate || !laborRate.popRates || !pop) {
      return null;
    }
    return laborRate.popRates.find(function (popRate) {
      return popRate.periodOfPerformance && popRate.periodOfPerformance.id === pop.id;
    }) || null;
  }

  hasLaborRateForPop(laborRate, pop) {
    const popRate = this.getPopRateForLaborRate(laborRate, pop);
    if (!popRate || popRate.id <= 0) {
      return false;
    }

    // Labor rates are created with empty pop-rate shells for every option year.
    // Only show the row on years that have actually been configured.
    const hasBasis = popRate.fixedFeeBasisId != null && popRate.fixedFeeBasisId !== '';
    const hasRate = popRate.rate != null && popRate.rate !== '' && Number(popRate.rate) > 0;
    return hasBasis || hasRate;
  }

  sortLaborRates(field, popId) {
    const sortField = field === 'popRate' && popId ? ('popRate_' + popId) : field;
    if (this.laborRateSort.field === sortField) {
      this.laborRateSort.reverse = !this.laborRateSort.reverse;
    } else {
      this.laborRateSort.field = sortField;
      this.laborRateSort.reverse = false;
    }
  }

  getFilteredAndSortedLaborRates(pop) {
    if (!this.subcontract || !this.subcontract.laborRates) {
      return [];
    }

    let rates = this.subcontract.laborRates.filter((laborRate) => this.hasLaborRateForPop(laborRate, pop));
    const filterText = (this.laborRateFilter.name || '').toLowerCase().trim();
    if (filterText) {
      rates = rates.filter(function (laborRate) {
        const name = (laborRate.name || '').toLowerCase();
        const category = (laborRate.laborCategory && laborRate.laborCategory.name || '').toLowerCase();
        const employee = (laborRate.employee || '').toLowerCase();
        return name.indexOf(filterText) >= 0 || category.indexOf(filterText) >= 0 || employee.indexOf(filterText) >= 0;
      });
    }

    const sortField = this.laborRateSort.field;
    const reverse = this.laborRateSort.reverse;
    const self = this;

    rates = rates.slice().sort(function (a, b) {
      let aVal;
      let bVal;
      if (sortField === 'laborCategory') {
        aVal = (a.laborCategory && a.laborCategory.name) || '';
        bVal = (b.laborCategory && b.laborCategory.name) || '';
      } else if (sortField === 'employee') {
        aVal = a.employee || '';
        bVal = b.employee || '';
      } else if (sortField && sortField.indexOf('popRate_') === 0) {
        const popId = Number(sortField.replace('popRate_', ''));
        const aPop = self.getPopRateForLaborRate(a, { id: popId });
        const bPop = self.getPopRateForLaborRate(b, { id: popId });
        aVal = aPop && aPop.rate != null ? Number(aPop.rate) : -1;
        bVal = bPop && bPop.rate != null ? Number(bPop.rate) : -1;
      } else {
        aVal = a.name || '';
        bVal = b.name || '';
      }

      if (aVal < bVal) {
        return reverse ? 1 : -1;
      }
      if (aVal > bVal) {
        return reverse ? -1 : 1;
      }
      return 0;
    });

    return rates;
  }

  getManagementFeePercentage() {
    if (this.attachedContract && this.attachedContract.subcontractManagementFeePercentage != null) {
      return Number(this.attachedContract.subcontractManagementFeePercentage) || 0;
    }
    return 0;
  }

  getPopRateManagementFeePercentage(popRate) {
    if (popRate && popRate.managementFeePercentage != null) {
      return Number(popRate.managementFeePercentage) || 0;
    }
    return this.getManagementFeePercentage();
  }

  getPopRateManagementFeeAmount(popRate) {
    if (!popRate) {
      return 0;
    }
    const rate = Number(popRate.rate) || 0;
    return rate * (this.getPopRateManagementFeePercentage(popRate) / 100);
  }

  getPopRateFeeAmount(popRate) {
    if (!popRate) {
      return 0;
    }
    return Number(popRate.feeRate) || 0;
  }

  getPopRateFullyLoaded(popRate) {
    if (!popRate) {
      return 0;
    }
    const negotiated = Number(popRate.rate) || 0;
    return negotiated + this.getPopRateManagementFeeAmount(popRate) + this.getPopRateFeeAmount(popRate);
  }

  formatRatePercent(value) {
    if (value == null || value === '') {
      return '0';
    }
    return formatCurrency(Number(value) || 0);
  }

  currency(value) {
    if (value == null || value === '') {
      return undefined;
    }
    return '$' + formatCurrency(Number(value));
  }

  formatDate(date, format) {
    return moment(date).format(format);
  }

  addLaborRate() {
    let self = this;
    let modalInstance = this.$uibModal.open(laborRateModal);
    modalInstance.subcontractMode = true;
    modalInstance.subcontractId = this.subcontract.id;
    modalInstance.subcontractorId = this.subcontract.subcontractorId;
    modalInstance.subcontractorShortName = this.subcontract.subcontractorShortName;
    modalInstance.primeContractId = this.attachedContract.id;
    modalInstance.contractId = this.attachedContract.id;
    modalInstance.laborCategories = this.attachedContract.laborCategories;
    modalInstance.costBased = this.isCostBasedContract();
    modalInstance.fixedFeeBasisList = this.fixedFeeBasisList || [];
    modalInstance.selectedPeriodOfPerformance = this.getSelectedLaborRatePop();
    modalInstance.formatFixedFeeBasisOption = (basis) => this.formatFixedFeeBasisOption(basis);
    modalInstance.contract = this.attachedContract;
    modalInstance.customer = this.selectedCustomer;

    modalInstance.success = function (laborRate) {
      const basisByPopId = laborRate.popRateFixedFeeBasisByPopId || {};
      const createChargeCodeRequest = laborRate.createChargeCodeRequest || null;
      delete laborRate.createChargeCodeRequest;
      delete laborRate.popRateFixedFeeBasisByPopId;
      laborRate.subcontractId = self.subcontract.id;
      laborRate.directRate = false;

      self.$http.post(self.$rootScope.apiHost + "/api/admin/subcontracts/" + self.subcontract.id + "/laborrates", laborRate, { withCredentials: true }).then(function (response) {
        const createdLaborRate = response.data;

        const popRateUpdates = (createdLaborRate.popRates || []).map(function (popRate) {
          const popId = popRate.periodOfPerformance && popRate.periodOfPerformance.id;
          const fixedFeeBasisId = popId ? basisByPopId[popId] : null;
          if (!fixedFeeBasisId || popRate.id <= 0) {
            return self.$q.resolve();
          }

          return self.$http.post(
            self.$rootScope.apiHost + '/api/admin/subcontracts/' + self.subcontract.id + '/laborrates/' + createdLaborRate.id + '/poprates/' + popRate.id,
            {
              rate: popRate.rate,
              periodOfPerformance: { id: popId },
              fixedFeeBasisId: Number(fixedFeeBasisId)
            },
            { withCredentials: true }
          );
        });

        return self.$q.all(popRateUpdates).then(function () {
          if (!createChargeCodeRequest) {
            self.toastr.success("Update Success", "SUCCESS");
            self.loadSubContract();
            modalInstance.dismiss();
            return;
          }

          return self.createChargeCodeForLaborRate(createdLaborRate, createChargeCodeRequest).then(function () {
            self.toastr.success("Labor rate and charge code created", "SUCCESS");
            self.loadSubContract();
            modalInstance.dismiss();
          }, function (failure) {
            self.toastr.warning(
              (failure.data && failure.data.message)
                ? failure.data.message
                : 'Labor rate was created, but the charge code could not be created.',
              'PARTIAL SUCCESS'
            );
            self.loadSubContract();
            modalInstance.dismiss();
          });
        });
      }, function (failure) {
        self.toastr.error("Update Failed", failure.data && failure.data.message ? failure.data.message : 'Could not add labor rate.');
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  createChargeCodeForLaborRate(createdLaborRate, request) {
    const popRate = (createdLaborRate.popRates || []).find(function (rate) {
      return rate.periodOfPerformance && rate.periodOfPerformance.id === request.periodOfPerformanceId;
    });

    if (!popRate || !popRate.id) {
      return this.$q.reject({ data: { message: 'Could not find the option-year pop rate for charge code creation.' } });
    }

    const pop = popRate.periodOfPerformance || this.getSelectedLaborRatePop() || {};
    const payload = {
      name: request.name,
      description: request.description,
      leaveType: false,
      billable: true,
      payable: true,
      payrollCostCategory: 'DIRECT',
      taskOrder: { id: request.projectId },
      popRate: { id: popRate.id },
      effectiveDate: pop.startDate ? moment(pop.startDate).format('YYYY-MM-DD') : null,
      expirationDate: pop.endDate ? moment(pop.endDate).format('YYYY-MM-DD') : null,
      users: [request.userId]
    };

    return this.$http.post(this.$rootScope.apiHost + '/api/admin/chargecodes', payload, { withCredentials: true });
  }

  initLaborRates() {
    if (!this.subcontract || !this.subcontract.laborRates || !this.attachedContract) {
      return;
    }

    let popsForContract = this.attachedContract.periodsOfPerformance || [];

    this.subcontract.laborRates.forEach(function (laborRate) {
      laborRate.popRates = laborRate.popRates || [];
      let missingPops = laborRate.popRates.length < popsForContract.length;

      if (missingPops) {
        let x = [];
        popsForContract.forEach(function (pop) {
          let existing = _.find(laborRate.popRates, function (r) {
            return r.periodOfPerformance && r.periodOfPerformance.id === pop.id;
          });

          if (!existing) {
            x.push({
              id: -1,
              periodOfPerformance: pop,
              rate: undefined,
              laborCategory: laborRate.laborCategory
            });
          }
        });

        x.forEach(function (record) {
          laborRate.popRates.push(record);
        });
      }
    });

    if (this.isCostBasedContract()) {
      this.attachFixedFeeBasisOptionsToLaborRates();
    }
  }

  updateLaborRateName(laborRate, name) {
    let self = this;
    this.$http.patch(
      this.$rootScope.apiHost + '/api/admin/contracts/' + this.attachedContract.id + '/laborrates/' + laborRate.id,
      { name: name },
      { withCredentials: true }
    ).then(function () {
      self.toastr.success('Labor rate name updated.', 'SUCCESS');
    }, function (failure) {
      self.toastr.error((failure.data && failure.data.message) || 'Could not update labor rate name.', 'ERROR');
      self.loadSubContract();
    });
  }

  updateLaborCategoryForLaborRate(laborRate, laborCategory) {
    let self = this;
    this.$http.patch(
      this.$rootScope.apiHost + '/api/admin/contracts/' + this.attachedContract.id + '/laborrates/' + laborRate.id + '/laborcategory/' + laborCategory.id,
      {},
      { withCredentials: true }
    ).then(function () {
      self.toastr.success('Labor category updated.', 'SUCCESS');
      self.loadSubContract();
    }, function (failure) {
      self.toastr.error((failure.data && failure.data.message) || 'Could not update labor category.', 'ERROR');
      self.loadSubContract();
    });
  }

  updateLaborRate(laborRate, popRate, newRate) {
    let self = this;
    popRate.rate = newRate;

    if (this.isCostBasedContract() && !this.resolvePopRateFixedFeeBasisId(popRate)) {
      this.toastr.warning('Select a fixed fee basis before saving the pop rate.');
      return;
    }

    if (popRate.id < 0) {
      this.$http.post(
        this.$rootScope.apiHost + '/api/admin/subcontracts/' + this.subcontract.id + '/laborrates/' + laborRate.id + '/poprates',
        this.buildPopRateSavePayload(popRate),
        { withCredentials: true }
      ).then(function () {
        self.refreshPopRates(laborRate);
        self.toastr.success('Labor Rate for PoP Successfully Added', 'SUCCESS');
      }, function (failure) {
        self.toastr.error((failure.data && failure.data.message) || 'Could not add pop rate.', 'ERROR');
      });
    } else {
      this.$http.post(
        this.$rootScope.apiHost + '/api/admin/subcontracts/' + this.subcontract.id + '/laborrates/' + laborRate.id + '/poprates/' + popRate.id,
        this.buildPopRateSavePayload(popRate),
        { withCredentials: true }
      ).then(function () {
        self.refreshPopRates(laborRate);
        self.toastr.success('Labor Rate for PoP Successfully Updated', 'SUCCESS');
      }, function (failure) {
        self.toastr.error((failure.data && failure.data.message) || 'Could not update pop rate.', 'ERROR');
      });
    }
  }

  refreshPopRates(laborRate) {
    let self = this;
    this.$http.get(this.$rootScope.apiHost + "/api/admin/subcontracts/" + this.subcontract.id + "/laborrates/" + laborRate.id + "/poprates", { withCredentials: true })
      .then(function (answer) {
        laborRate.popRates = answer.data;
        self.initLaborRates();
      });
  }

  viewChargeCodes(laborRate, popRate) {
    let modalInstance = this.$uibModal.open(viewChargeCodesModal);
    modalInstance.laborRate = laborRate;
    modalInstance.popRate = popRate;
    modalInstance.chargeCodes = (popRate && popRate.chargeCodes) ? popRate.chargeCodes : [];
  }

  deleteLaborRate(laborRate) {
    let self = this;
    if (!window.confirm('Delete labor rate "' + (laborRate.name || '') + '"?')) {
      return;
    }

    this.$http.delete(
      this.$rootScope.apiHost + '/api/admin/subcontracts/' + this.subcontract.id + '/laborrates/' + laborRate.id,
      { withCredentials: true }
    ).then(function () {
      self.toastr.success('Successfully deleted labor rate.', 'SUCCESS');
      _.remove(self.subcontract.laborRates, function (lr) {
        return laborRate.id === lr.id;
      });
    }).catch(function (err) {
      const message = err.data && err.data.message ? err.data.message : 'Could not delete labor rate.';
      self.toastr.error(message, 'ERROR');
    });
  }

  updateSubcontractDetails(parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;
    this.$http.patch(this.$rootScope.apiHost + "/api/admin/subcontracts/" + this.subcontract.id, obj, { withCredentials: true }).then(function () {
      self.toastr.success("Successfully updated subcontract details!", "SUCCESS");
    }, function () {
      self.toastr.error("Could not update subcontract details.", "ERROR");
    });
  }

  loadFixedFeeBasis() {
    if (!this.isCostBasedContract() || !this.attachedContract) {
      return;
    }

    let self = this;
    this.$http.get(this.$rootScope.apiHost + '/api/admin/contracts/' + this.attachedContract.id + '/fixedfeebasis', { withCredentials: true })
      .then(function (response) {
        self.fixedFeeBasisList = response.data || [];
        self.attachFixedFeeBasisOptionsToLaborRates();
      })
      .catch(function () {
        self.toastr.error('Could not load fixed fee basis rows.', 'ERROR');
      });
  }

  formatFixedFeeBasisOption(basis) {
    let label = (basis.modLabel || 'Basis') + ' — effective ' + moment(basis.effectiveDate).format('MMM DD, YYYY');
    if (basis.expirationDate) {
      label += ' – ' + moment(basis.expirationDate).format('MMM DD, YYYY');
    }
    return label;
  }

  getFixedFeeBasisOptionsForPopRate(laborRate, pop) {
    const popId = pop.periodOfPerformance && pop.periodOfPerformance.id;
    const laborCategory = pop.laborCategory || laborRate.laborCategory;
    const laborCategoryId = laborCategory && laborCategory.id;
    if (!popId || !laborCategoryId) {
      return [];
    }
    return (this.fixedFeeBasisList || []).filter(function (basis) {
      return basis.periodOfPerformanceId === popId && basis.laborCategoryId === laborCategoryId;
    });
  }

  syncPopRateFixedFeeBasisSelection(popRate) {
    if (!popRate) {
      return;
    }

    const options = popRate.availableFixedFeeBasisOptions || [];
    if (popRate.fixedFeeBasisId != null && popRate.fixedFeeBasisId !== '') {
      const basisId = Number(popRate.fixedFeeBasisId);
      popRate.selectedFixedFeeBasis = options.find(function (basis) {
        return basis.id === basisId;
      }) || null;
      popRate.fixedFeeBasisId = basisId;
    } else {
      popRate.selectedFixedFeeBasis = null;
      popRate.fixedFeeBasisId = null;
    }
  }

  attachFixedFeeBasisOptionsToLaborRates() {
    if (!this.isCostBasedContract() || !this.subcontract || !this.subcontract.laborRates) {
      return;
    }

    let self = this;
    this.subcontract.laborRates.forEach(function (laborRate) {
      (laborRate.popRates || []).forEach(function (popRate) {
        popRate.availableFixedFeeBasisOptions = self.getFixedFeeBasisOptionsForPopRate(laborRate, popRate);
        self.syncPopRateFixedFeeBasisSelection(popRate);
      });
    });
  }

  resolvePopRateFixedFeeBasisId(popRate) {
    if (popRate.selectedFixedFeeBasis && popRate.selectedFixedFeeBasis.id != null) {
      return Number(popRate.selectedFixedFeeBasis.id);
    }
    if (popRate.fixedFeeBasisId != null && popRate.fixedFeeBasisId !== '') {
      return Number(popRate.fixedFeeBasisId);
    }
    return null;
  }

  hasPopRateFixedFeeBasis(popRate) {
    return this.resolvePopRateFixedFeeBasisId(popRate) != null;
  }

  canEditPopRateFixedFeeBasis(popRate) {
    if (!this.isCostBasedContract()) {
      return false;
    }
    return !this.hasPopRateFixedFeeBasis(popRate);
  }

  getPopRateFixedFeeBasisLabel(popRate) {
    if (popRate.fixedFeeModLabel) {
      return popRate.fixedFeeModLabel;
    }
    if (popRate.selectedFixedFeeBasis) {
      return this.formatFixedFeeBasisOption(popRate.selectedFixedFeeBasis);
    }
    const basisId = popRate.fixedFeeBasisId != null ? Number(popRate.fixedFeeBasisId) : null;
    if (basisId && popRate.availableFixedFeeBasisOptions) {
      const basis = popRate.availableFixedFeeBasisOptions.find(function (row) {
        return row.id === basisId;
      });
      if (basis) {
        return this.formatFixedFeeBasisOption(basis);
      }
    }
    return '—';
  }

  buildPopRateSavePayload(popRate) {
    const payload = {
      rate: popRate.rate,
      periodOfPerformance: {
        id: popRate.periodOfPerformance.id
      }
    };

    if (popRate.id > 0) {
      payload.id = popRate.id;
    }

    if (this.isCostBasedContract()) {
      const fixedFeeBasisId = this.resolvePopRateFixedFeeBasisId(popRate);
      if (fixedFeeBasisId != null) {
        payload.fixedFeeBasisId = fixedFeeBasisId;
      }
    }

    return payload;
  }

  savePopRateFixedFeeBasis(laborRate, popRate) {
    const fixedFeeBasisId = this.resolvePopRateFixedFeeBasisId(popRate);
    popRate.fixedFeeBasisId = fixedFeeBasisId;

    if (!fixedFeeBasisId) {
      return;
    }

    if (popRate.id < 0) {
      if (popRate.rate != null && popRate.rate !== '') {
        this.updateLaborRate(laborRate, popRate, popRate.rate);
      }
      return;
    }

    let self = this;
    const payload = this.buildPopRateSavePayload(popRate);
    this.$http.post(
      this.$rootScope.apiHost + '/api/admin/subcontracts/' + this.subcontract.id + '/laborrates/' + laborRate.id + '/poprates/' + popRate.id,
      payload,
      { withCredentials: true }
    ).then(function () {
      self.refreshPopRates(laborRate);
      self.toastr.success('Fixed fee basis updated for pop rate.', 'SUCCESS');
    }, function (failure) {
      popRate.selectedFixedFeeBasis = null;
      popRate.fixedFeeBasisId = null;
      self.toastr.error((failure.data && failure.data.message) || 'Could not update fixed fee basis.', 'ERROR');
    });
  }

  onPopRateBasisChange(laborRate, popRate) {
    if (!popRate) {
      return;
    }

    let self = this;
    setTimeout(function () {
      if (popRate.selectedFixedFeeBasis) {
        popRate.fixedFeeBasisId = Number(popRate.selectedFixedFeeBasis.id);
      }
      self.savePopRateFixedFeeBasis(laborRate, popRate);
    }, 0);
  }
}


export default SubcontractDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontract-details/subcontract-details.controller.js